<template>
  <a
    :href="jobHref"
    :target="target"
    class="joboffer-box__tile__wrapper"
    @click="navigateToJob"
  >
    <v-card class="joboffer-box joboffer-box--tile" elevation="0">
      <v-img :aspect-ratio="16 / 7" :src="imageUrl"></v-img>

      <v-card-title>
        <h3>
          <span v-if="isFieldEnabled('job-code')">
            {{ joboffer.jobCode }} &mdash;
          </span>
          {{ jobName }}
        </h3>
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-wrap text-sm">
          <item-field
            v-for="field in jobDataFields"
            :key="`job-item_${field}`"
            :joboffer="joboffer"
            :field="field"
          ></item-field>
        </div>
      </v-card-text>
    </v-card>
  </a>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import itemField from './joboffer-item-fields/item-field.vue';

export default {
  props: {
    joboffer: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('companyModule', {
      showExternalAdvert: 'showExternalAdvert',
      jobDataFields: 'jobDataFields'
    }),

    ...mapGetters('companyModule', {
      isInternal: 'userIsInternal'
    }),

    ...mapState({
      currentLanguage: 'currentLanguage'
    }),

    imageUrl() {
      if (this.joboffer.headerImages && this.joboffer.headerImages.length > 0) {
        return this.joboffer.headerImages[0].thumbnailUrl;
      }

      return '';
    },

    jobHref() {
      if (this.showExternalAdvert) {
        return `${this.joboffer.advertUrl}?lang=${this.currentLanguage}`;
      } else {
        const routePath = this.$router.resolve({
          name: 'jobDetails',
          params: {
            jobId: this.joboffer.jobofferId,
            jobName: 'joboffer-name'
          }
        }).href;

        return window.location.origin + routePath;
      }
    },

    jobName() {
      return this.isInternal
        ? this.localize(this.joboffer.internalName) || this.localize(this.joboffer.name)
        : this.localize(this.joboffer.name);
    },

    target() {
      if (this.showExternalAdvert) {
        return '_blank';
      } else {
        return '_self';
      }
    }
  },

  methods: {
    navigateToJob(event) {
      if (this.shouldOpenInNewTab(event) || this.showExternalAdvert) {
        return;
      }

      event?.preventDefault?.();
      this.$router.push({
        name: 'jobDetails',
        params: {
          jobId: this.joboffer.jobofferId,
          jobName: 'joboffer-name'
        }
      });
    },

    shouldOpenInNewTab(event) {
      return (
        !event ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.button === 1 ||
        event.altKey
      );
    },

    isFieldEnabled(fieldName) {
      return this.jobDataFields.includes(fieldName);
    }
  },

  components: {
    itemField
  }
};
</script>

<style scoped>
.joboffer-box:hover {
  cursor: pointer;
}

a.joboffer-box__tile__wrapper {
  color: inherit;
  text-decoration: none;
}

h3 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: var(--font-size-lg) !important;
  margin-bottom: 0 !important;
}
</style>
